import React, { useEffect, useState, useContext } from 'react';

import '../../../assets/scss/filtersection.scss';

import { Button, Collapse, Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import yellowTick from '../../../assets/images/collection/yellow-tick_20px.svg';
import { ThemeContext } from '../../context/context';
import {
    useAccount,
} from 'wagmi'
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import DataService from '../../../lib/DataService';

const FilterActivitySection = () => {

    const [isOpenCollapse1, setIsOpenCollapse1] = useState(false);
    const toggleCollapse1 = () => {
        setIsOpenCollapse1(!isOpenCollapse1);
    }
    const [isOpenCollapse2, setIsOpenCollapse2] = useState(false);
    const toggleCollapse2 = () => {
        setIsOpenCollapse2(!isOpenCollapse2);
    }

    const { address, isConnected } = useAccount()
    const { id } = useParams()
    const { offerCollection, setOfferCollection } = useContext(ThemeContext)
    const {  postRequest } = DataService()

    useEffect(() => {
        GetFilterCollection()
    }, [address, id])
    const { t } = useTranslation()

    const [collection, setCollection] = useState()

    const GetFilterCollection = async () => {
        const getcollection = await postRequest("user/offers_received_collections", { "address": id ? id : address })
        if (getcollection.status == true) {
            setCollection(getcollection.data)
        }
    }


    const handleCheckboxCollection = (item) => {
        let a = offerCollection.includes(item.collectionName)

        if (a == true) {

            const index = offerCollection.indexOf(item.collectionName);
            if (index > -1) {
                offerCollection.splice(index, 1);
                const nerArr = [...offerCollection]
                setOfferCollection(nerArr);
            }

        } else if (a == false) {
            setOfferCollection(
                [...offerCollection, item.collectionName]
            );
        }
    }

    const handleOnKeyDown = async (e) => {
        if (e.key == 'Enter' || e.key == "") {
            const searchcollection = await postRequest("user/offers_received_collections", { "address": id ? id : address, "search": e.target.value })
            if (searchcollection.status == true) {
                setCollection(searchcollection.data)
            }
            else {
                setCollection("")
            }
        }
    }

    return (
        <>
            <div className='filtercard'>
                <div>
                    <Button className='filterTit' onClick={toggleCollapse1}>
                        <span>{t("Collection")}</span>
                        <i className={`fas ${isOpenCollapse1 ? 'fa-angle-up' : 'fa-angle-down'}`} ></i>
                    </Button>
                    <Collapse isOpen={isOpenCollapse1}>
                        <div className='collapseCnt'>
                            <div className="form-group formInputs">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText className='px-2'>
                                            <svg
                                                width="17"
                                                height="17"
                                                viewBox="0 0 17 17"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M15.875 14.6562C16.0312 14.8125 16.0312 15.0625 15.875 15.1875L15.1562 15.9062C15.0312 16.0625 14.7812 16.0625 14.625 15.9062L10.8438 12.125C10.7812 12.0312 10.75 11.9375 10.75 11.8438V11.4375C9.59375 12.4062 8.125 13 6.5 13C2.90625 13 0 10.0938 0 6.5C0 2.9375 2.90625 0 6.5 0C10.0625 0 13 2.9375 13 6.5C13 8.125 12.375 9.625 11.4062 10.75H11.8125C11.9062 10.75 12 10.8125 12.0938 10.875L15.875 14.6562ZM6.5 11.5C9.25 11.5 11.5 9.28125 11.5 6.5C11.5 3.75 9.25 1.5 6.5 1.5C3.71875 1.5 1.5 3.75 1.5 6.5C1.5 9.28125 3.71875 11.5 6.5 11.5Z"
                                                    fill="white"
                                                />
                                            </svg>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder={t("Search collection")} name="searchInput" onKeyDown={handleOnKeyDown} />
                                </InputGroup>
                            </div>

                            <div className='filterInnercard'>
                                <div class="scroller htcheckbox">
                                    {collection && collection.length > 0 ?
                                        collection && collection.map((data, index) =>
                                        (
                                            <div class="d-flex align-items-center mb-2" key={data.id}>
                                                <label class="cuschk mr-2 mb-0" For={`checkbox${index + 1}`}>
                                                    <input type="checkbox" id={`checkbox${index + 1}`} name="collectionchoose" checked={offerCollection.length > 0 ? offerCollection.includes(data.collectionName) : false} onChange={() => handleCheckboxCollection(data)} />
                                                    <span class="checkmark"></span>
                                                </label>
                                                <h3 className='mb-0 filterLabel'>{data.collectionName}</h3>
                                                <img src={data.verification == "Verified" ? yellowTick : ""} className="ml-1" />
                                                <h3 className='mb-0 filterLabel dark-text-secondary ml-auto'>{data.totalNFTs}</h3>
                                            </div>
                                        ))
                                        :
                                        t("No Data Found")
                                    }
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>
            </div>
        </>
    );
}

export default FilterActivitySection;